import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import {
  ADD_BOX_STORAGE,
  CREATE_BOX,
  GET_AVAILABLE_BOXES,
  GET_BOX_STORAGE,
  GET_BOX_STORAGE_HISTORY,
  REMOVE_BOX_STORAGE,
  RENEW_BOX_STORAGE,
  VALIDATE_BOX_STORAGE,
} from "../../configs/apiConfig";

import { BaseResponse, BaseResponseSingle } from "../../typings/interfaces";
import {
  AddBoxStorageBody,
  availableBoxResponse,
  BoxConfigResponse,
  BoxStorageResponse,
  BoxStorageValidationResponse,
  CreateBoxBody,
  IBoxStorageHistoryRow,
  RenewBoxStorageBody,
} from "../../typings/interfaces/responses/boxStorageResponse";

export const addBoxStorageAction = createAsyncThunk(
  "boxStorage/add",
  async (payload: AddBoxStorageBody, { rejectWithValue }) => {
    try {
      const { data } = await axios.post<{ body: AddBoxStorageBody }>(
        ADD_BOX_STORAGE,
        payload
      );
      return data.body;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getBoxStorageAction = createAsyncThunk(
  "boxStorage/get",
  async (billId: number, { rejectWithValue }) => {
    try {
      const { data } = await axios.get<BaseResponse<AddBoxStorageBody>>(
        `${GET_BOX_STORAGE}/${billId}`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const removeBoxStorageAction = createAsyncThunk(
  "boxStorage/remove",
  async (billId: number, { rejectWithValue }) => {
    try {
      const response = await axios.delete<BaseResponse<BoxStorageResponse>>(
        `${REMOVE_BOX_STORAGE}/${billId}`
      );
      return { response: response.data };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const validateBoxStorageAction = createAsyncThunk(
  "boxStorage/validate",
  async (billId: number, { rejectWithValue }) => {
    try {
      const response = await axios.get<
        BaseResponse<BoxStorageValidationResponse>
      >(`${VALIDATE_BOX_STORAGE}/${billId}`);
      return { response: response.data };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAvailableBoxAction = createAsyncThunk(
  "boxStorage/availableBox",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.get<BaseResponse<availableBoxResponse>>(
        `${GET_AVAILABLE_BOXES}`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getBoxStorageHistoryByCustomerIdAction = createAsyncThunk(
  "boxStorage/history",
  async (customerId: number, { rejectWithValue }) => {
    try {
      const { data } = await axios.get<BaseResponse<IBoxStorageHistoryRow[]>>(
        `${GET_BOX_STORAGE_HISTORY}/${customerId}/history`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const renewBoxStorageAction = createAsyncThunk(
  "boxStorage/renew",
  async (payload: RenewBoxStorageBody, { rejectWithValue }) => {
    try {
      const { data } = await axios.put<BaseResponse<AddBoxStorageBody[]>>(
        RENEW_BOX_STORAGE,
        payload
      );
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const createBoxAction = createAsyncThunk(
  "boxConfig/create",
  async (payload: CreateBoxBody, { rejectWithValue }) => {
    try {
      const { data } = await axios.post<BaseResponseSingle<BoxConfigResponse>>(
        CREATE_BOX,
        payload
      );
      return data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
